import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {ScheduleCardScratchpadState} from '../../scratchpad/scheduleCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const setRandomizeOutputsInputSchema = z.object({
  randomizeOutputs: z
    .boolean()
    .describe(
      'When multiple outputs match the current time: false = use first match, true = pick random among matches',
    ),
});

export default function setRandomizeOutputsTool() {
  async function execute(
    params: ToolExecuteParams<typeof setRandomizeOutputsInputSchema, ScheduleCardScratchpadState>,
  ) {
    const {randomizeOutputs} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<ScheduleCardScratchpadState>(
      agentScratchpad,
      NodeType.SCHEDULE,
    );

    validatedScratchpad.card.randomizeOutputs = randomizeOutputs;

    return toolResult(
      `Randomize outputs set to ${randomizeOutputs ? 'random among matches' : 'first match'}`,
    );
  }

  return tool<typeof setRandomizeOutputsInputSchema, ScheduleCardScratchpadState>({
    name: V2CardAgentToolName.SetRandomizeOutputs,
    displayName: 'Setting randomize outputs',
    description:
      'Set whether to randomize when multiple outputs match (first match vs random among matches).',
    inputSchema: setRandomizeOutputsInputSchema,
    execute,
  });
}
